/** Import step keys for tenant onboarding CSV/spreadsheet flow. */
export const CSV_IMPORT_KEYS = {
  tenantCompany: 'tenantCompany',
  facilities: 'facilities',
  suppliers: 'suppliers',
  supplierFacilities: 'supplierFacilities',
  commodities: 'commodities',
  geographies: 'geographies',
  logistics: 'logistics',
  products: 'products',
  graphOverview: 'graphOverview',
};

export const CSV_IMPORT_SEQUENCE = [
  CSV_IMPORT_KEYS.tenantCompany,
  CSV_IMPORT_KEYS.facilities,
  CSV_IMPORT_KEYS.suppliers,
  CSV_IMPORT_KEYS.supplierFacilities,
  CSV_IMPORT_KEYS.commodities,
  CSV_IMPORT_KEYS.geographies,
  CSV_IMPORT_KEYS.logistics,
  CSV_IMPORT_KEYS.products,
  CSV_IMPORT_KEYS.graphOverview,
];
